import PinBlock from './PinBlock';

export default PinBlock;
